import { css } from '@spectrum-web-components/base';
const styles = css`
    #list{--spectrum-tabs-font-weight:var(--system-tabs-font-weight);--spectrum-tabs-divider-background-color:var(--system-tabs-divider-background-color)}
`;
export default styles;